import { PLACEMENT } from '../types/Placement';
export const toArrowPlacement = placement => {
  switch (placement) {
    case PLACEMENT.TOP:
      return PLACEMENT.BOTTOM;
    case PLACEMENT.BOTTOM:
      return PLACEMENT.TOP;
    case PLACEMENT.LEFT:
      return PLACEMENT.RIGHT;
    case PLACEMENT.RIGHT:
      return PLACEMENT.LEFT;
    case PLACEMENT.LEFT_TOP:
      return PLACEMENT.RIGHT_BOTTOM;
    case PLACEMENT.RIGHT_TOP:
      return PLACEMENT.LEFT_BOTTOM;
    case PLACEMENT.LEFT_BOTTOM:
      return PLACEMENT.RIGHT_TOP;
    case PLACEMENT.RIGHT_BOTTOM:
      return PLACEMENT.LEFT_TOP;
    case PLACEMENT.TOP_LEFT:
      return PLACEMENT.BOTTOM_RIGHT;
    case PLACEMENT.TOP_RIGHT:
      return PLACEMENT.BOTTOM_LEFT;
    case PLACEMENT.BOTTOM_LEFT:
      return PLACEMENT.TOP_RIGHT;
    case PLACEMENT.BOTTOM_RIGHT:
      return PLACEMENT.TOP_LEFT;
    default:
      return placement;
  }
};